'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavSubItemGroup", {
    enumerable: true,
    get: function() {
        return NavSubItemGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavSubItemGroup = require("./useNavSubItemGroup");
const _renderNavSubItemGroup = require("./renderNavSubItemGroup");
const _useNavSubItemGroupStylesstyles = require("./useNavSubItemGroupStyles.styles");
const NavSubItemGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavSubItemGroup.useNavSubItemGroup_unstable)(props, ref);
    (0, _useNavSubItemGroupStylesstyles.useNavSubItemGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavSubItemGroupStyles_unstable')(state);
    return (0, _renderNavSubItemGroup.renderNavSubItemGroup_unstable)(state);
});
NavSubItemGroup.displayName = 'NavSubItemGroup';
